import React, { useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Card } from "@/components/admin/ui";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user } = useAuth() as any;
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) return setError("The new passwords don't match.");
    if (pw.length < 10 || !/[A-Za-z]/.test(pw) || !/\d/.test(pw)) return setError("Use at least 10 characters, including letters and at least one number.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Your password has been changed.");
      setCur(""); setPw(""); setPw2("");
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };
  const field = (label: string, v: string, set: (s: string) => void, id: string, auto: string) => (
    <label className="block"><span className="field-label">{label}</span>
      <input type="password" required autoComplete={auto} className="field-input" value={v} onChange={(e) => set(e.target.value)} data-testid={id} />
    </label>
  );
  return (
    <div>
      <PageHeader title="My account" subtitle={user?.email} />
      <Card title="Change my password" testId="change-password-card">
        <form onSubmit={submit} className="max-w-md space-y-4 p-6" data-testid="change-password-form">
          {field("Current password", cur, setCur, "current-password-input", "current-password")}
          {field("New password", pw, setPw, "new-password-input", "new-password")}
          {field("Confirm new password", pw2, setPw2, "confirm-password-input", "new-password")}
          <p className="text-xs text-[#64748B]">At least 10 characters, with letters and at least one number.</p>
          {error && <p className="rounded-lg bg-[#FEE2E2] px-3 py-2 text-sm text-[#991B1B]" data-testid="change-password-error">{error}</p>}
          <button className="btn-primary" disabled={busy} data-testid="change-password-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Change password</button>
        </form>
      </Card>
    </div>
  );
}
